import React from 'react';
import '../styles/components/UsersList.scss';
import { Box, 
  Typography, 
  Button,
  Modal } from '@mui/material';

const defaultMessage = "¿Estás seguro de que deseas eliminar?"

function DeleteModal({openConfirmModal, selectedItem, handleCloseConfirmModal, onDelete, message = defaultMessage}) {

  const handleConfirmDelete = () => {
    if (selectedItem) {
      onDelete(selectedItem.id);
    }
    handleCloseConfirmModal();
  };

  return (
    <Modal open={openConfirmModal} onClose={handleCloseConfirmModal}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Confirmar eliminación
        </Typography>
        <Typography variant="body1" gutterBottom>
          {message}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
          <Button onClick={handleCloseConfirmModal} sx={{ marginRight: 1 }} data-testid="modal-cancel-button">
            Cancelar
          </Button>
          <Button data-testid='modal-delete-button' role='button' variant="contained" color="error" onClick={handleConfirmDelete}>
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default DeleteModal;
